import { Injectable } from '@angular/core';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types';

@Injectable()
export class SliderFactory {
  public createSwiper(container: HTMLElement, slides: HTMLElement[], options?: SwiperOptions): Swiper {
    const swiper: Swiper = new Swiper(container, options);

    slides.forEach(slide => {
      slide.classList.add('swiper-slide');
    });

    swiper.appendSlide(slides);

    return swiper;
  }
}
